import { NewCompanyDialogComponent } from '../dialogs/new-company-dialog/new-company-dialog.component';

export { NewCompanyDialogComponent };
